import {Component, OnInit} from '@angular/core';
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudentService} from "../../services/mygreencountry/student.service";
import {CountricsHistory} from "../../types/interfaces";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {CharityArray, CountricsUrls} from "../../types/apiResponse.interface";
import {COUNTRICS_LINKS} from "../../shared/constants";
import {DomSanitizer, SafeResourceUrl, Title} from "@angular/platform-browser";
import {ViewTestComponent} from "../../shared/components/modals/view-test/view-test.component";
import {ModalController} from "@ionic/angular";
import {TranslocoService} from "@jsverse/transloco";
import {Observable} from "rxjs";
import {
    CharityDonateFormComponent
} from "../../shared/components/modals/charity-donate-form/charity-donate-form.component";
import {
    CharityDonateLimitExceededComponent
} from "../../shared/components/modals/charity-donate-limit-exceeded/charity-donate-limit-exceeded.component";

@Component({
    selector: 'app-countrics',
    templateUrl: './countrics.page.html',
    styleUrls: ['./countrics.page.scss'],
})
export class CountricsPage implements OnInit {
    title$: Observable<string>;
    lang = 'uk';

    public countrics: number = 0;
    public history: CountricsHistory[] | [] = [];
    public url: CountricsUrls = COUNTRICS_LINKS;
    public showMoreBottom: boolean = false;
    public videoUrl: string;

    public charity: CharityArray;


    constructor(private preloaderService: PreloaderService,
                private studentService: StudentService,
                public myGcService: MyGreenCountry,
                private sanitizer: DomSanitizer,
                private modalCtrl: ModalController,
                private translocoService: TranslocoService,
                private titleService: Title,
    )
    {
        this.translocoService.langChanges$.subscribe(language => {
            this.lang = language;
        })

        this.title$ = this.translocoService.selectTranslate('route.countrics');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });


    }

    ngOnInit() {
        // console.log('lod')
        //
        // this.loadCountrics();

    }

    ionViewDidEnter() {
        this.loadCountrics();
    }

    refresh(event: any) {
        this.loadCountrics(false, event);

    }

    async loadCountrics(withoutLimit: boolean = false, event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.studentService.getCountricsHistory(withoutLimit)
            .subscribe({

                next: (response) => {
                    this.history = response.history;
                    this.countrics = response.amount;
                    this.url = response.url
                    this.videoUrl = response.videoUrl;
                    this.showMoreBottom = response.moreStory;

                    this.charity = response.charity;

                },

                error: (error) => {
                    console.log('error', error)
                },

                complete: () => {
                    this.preloaderService.hideLoading();
                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }


    openUrl(url: string) {

        this.myGcService.openUrl(url);

    }

    async openModal(url: string) {
        const safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        const modal = await this.modalCtrl.create({
            component: ViewTestComponent,
            cssClass: 'full-height',
            componentProps: {
                url: safeUrl,
                isCountrics:true
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

    getCharityProgressWith(){
        let limit = this.charity.limit;

        if(this.charity?.limit && this.charity?.current){
           return Math.round((this.charity.current / this.charity.limit) * 100) + '%';
        }
        return '0%';
    }

    getCharityProgressPoint(index:number){

        if(this.charity?.limit){

            return Math.round((this.charity.limit / 4) * index);

        }

        return 0;
    }

    isProgressPointDone(index:number){
        let part =  Math.round((this.charity.limit / 4) * index);

        if(this.charity?.current){
            if(this.charity?.current > part){
                return false;
            }
        }

        return true;
    }

    async donate() {

        if(this.charity?.limit > this.charity?.current){
            await this.donateModal()
        }else{
            await this.showCharityLimitModal();
        }

    }

    async donateModal() {

        const modal = await this.modalCtrl.create({
            component: CharityDonateFormComponent,
            cssClass: 'charity-form-modal auto-height',
            componentProps: {
                charity: this.charity,
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

    async showCharityLimitModal(){

        const modal = await this.modalCtrl.create({
            component: CharityDonateLimitExceededComponent,
            cssClass: 'charity-limit-exceeded-modal auto-height'
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }

}
